import { motion } from "framer-motion";
import React from "react";
import { useNavigate } from "react-router-dom";

const ConfirmationPage = ({ transactionId }) => {
  const navigate = useNavigate(); // ✅ useNavigate must be called

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-black flex items-center justify-center px-4">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-md w-full bg-gray-800/50 backdrop-blur-sm rounded-2xl border border-gray-700 shadow-2xl p-8 text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="w-20 h-20 bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <svg
            className="w-12 h-12 text-green-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </motion.div>

        <h2 className="text-3xl font-bold text-white mb-4">
          Payment Confirmed!
        </h2>
        <p className="text-gray-400 mb-2">Your transaction was successful</p>

        <div className="bg-gray-900/50 rounded-lg p-4 mb-8 mt-6">
          <p className="text-gray-400">Transaction ID</p>
          <p className="text-cyan-400 font-mono text-lg break-all">
            {transactionId}
          </p>
        </div>

        <p className="text-gray-300 mb-8">
          Your eBook is being prepared for download. You'll receive an email
          with your download link shortly.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <motion.button
            onClick={() => navigate("/home")}
            className="px-6 py-3 bg-gradient-to-r from-blue-600 to-cyan-500 text-white font-medium rounded-lg"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Return to Home
          </motion.button>
          <motion.button
            onClick={() => navigate("/library")}
            className="px-6 py-3 bg-gray-700 text-white font-medium rounded-lg"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Go to My Library
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default ConfirmationPage;
